import { ComposeViewState } from 'owa-mail-compose-store';
import Item from 'owa-service/lib/contract/Item';

export let getComposeItemId = (viewState: ComposeViewState) => () => {
    return viewState.itemId ? viewState.itemId.Id : null;
};

export let getReadItemId = (item: Item) => () => {
    return item.ItemId.Id;
};
